import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'react-router-dom'
import NoGlobalRolesRoute from 'components/routes/NoGlobalRoles'

import {
  GLOBAL_ROLES,
} from 'containers/Role/constants'

import NvqualSubmissionsPage from 'containers/Manage/NvqualSubmissions/NvqualSubmissions'
import NvbugsPage from 'containers/Manage/Nvbugs/Nvbugs'

import {
    NVBUGS_PATHNAME,
    NVQUAL_PATHNAME,
    PVPS_PATHNAME
} from './constants'

const ReportRoute = props => {
    // legacy hyperlink redirect when unassociated nvbugs belonged to nvqual and pvp components
    const { pathname, search } = props.location 
    const urlParams = new URLSearchParams(search);
    const nvbugParam = urlParams.get('nvbug');
    const redirectPaths = [NVQUAL_PATHNAME, PVPS_PATHNAME] 
    if (redirectPaths.includes(pathname) && nvbugParam) {
        return <Redirect to={{pathname: NVBUGS_PATHNAME, search }} />
    }

    return (
        <Switch>
            <NoGlobalRolesRoute exact path={NVBUGS_PATHNAME} roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={NvbugsPage}/>
            <NoGlobalRolesRoute exact path={NVQUAL_PATHNAME} roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={NvqualSubmissionsPage}/>
        </Switch>
    )
}

export default ReportRoute
